import {SET_LANGUAGE} from '../actions/timeline';

import about from '../../data/about.js';
import aboutNL from '../../data/nl/about.js';

const defaultState = {
    body: about
};

export default function(state = defaultState, action) {

    switch(action.type) {

        case SET_LANGUAGE:
            // Make language en / nl
            const language = action.payload;

            // NL
            if (language === "nl") {
                return {
                    ...state,
                    body: aboutNL
                };
            }

            // EN
            return {
                ...state,
                body: about
            };

        default:

            return state;

    }

}


// WEBPACK FOOTER //
// ./src/state/reducers/about.js